import React from 'react';

export const ConexoLogo = ({ size = 24, variant = 'full', className = '' }) => {
    const iconSize = size;
    const textSize = size * 0.8;

    const Icon = () => (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="drop-shadow-[0_0_8px_rgba(59,130,246,0.3)] animate-pulse-slow"
        >
            <defs>
                <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="var(--accent)" />
                    <stop offset="100%" stopColor="var(--primary)" />
                </linearGradient>
                <filter id="glow">
                    <feGaussianBlur stdDeviation="2.5" result="coloredBlur" />
                    <feMerge>
                        <feMergeNode in="coloredBlur" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>
            {/* Network Hexagon */}
            <path
                d="M50 5L89 27.5V72.5L50 95L11 72.5V27.5L50 5Z"
                stroke="url(#logo-gradient)"
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="rgba(59, 130, 246, 0.05)"
            />
            {/* Central Node */}
            <circle cx="50" cy="50" r="8" fill="url(#logo-gradient)" filter="url(#glow)" />
            {/* Connecting Lines */}
            <path d="M50 50L50 20M50 50L76 65M50 50L24 65" stroke="var(--primary)" strokeWidth="4" strokeLinecap="round" opacity="0.6" />
            {/* Points */}
            <circle cx="50" cy="20" r="4" fill="var(--accent)" />
            <circle cx="76" cy="65" r="4" fill="var(--primary)" />
            <circle cx="24" cy="65" r="4" fill="var(--primary)" />
        </svg>
    );

    if (variant === 'icon') return <Icon />;

    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <Icon />
            <div className="flex flex-col leading-none">
                <span
                    style={{ fontSize: `${textSize}px`, letterSpacing: '-0.02em' }}
                    className="font-black text-white tracking-tight"
                >
                    CONEXO <span className="text-glow-primary" style={{ color: 'var(--primary)' }}>POS</span>
                </span>
                <span
                    className="text-[9px] uppercase font-bold tracking-[0.25em] mt-1 opacity-50"
                    style={{ color: 'var(--text-soft)' }}
                >
                    SaaS Platform
                </span>
            </div>
        </div>
    );
};

export default ConexoLogo;
